<div class="webapp min-full-height">
  <main id="main">
    <router-outlet></router-outlet>
  </main>
</div>
